import valid from 'semver/functions/valid.js';
import major from 'semver/functions/major.js';

class ProxyBus {
    bus;
    constructor(bus) {
        if (typeof bus.getVersion !== 'function' || !valid(bus.getVersion())) {
            console.warn('Proxying an event bus with an unknown or invalid version');
        }
        else if (major(bus.getVersion()) !== major(this.getVersion())) {
            console.warn('Proxying an event bus of version ' + bus.getVersion() + ' with ' + this.getVersion());
        }
        this.bus = bus;
    }
    getVersion() {
        return "3.1.0";
    }
    subscribe(name, handler) {
        this.bus.subscribe(name, handler);
    }
    unsubscribe(name, handler) {
        this.bus.unsubscribe(name, handler);
    }
    emit(name, event) {
        this.bus.emit(name, event);
    }
}

class SimpleBus {
    handlers = new Map();
    getVersion() {
        return "3.1.0";
    }
    subscribe(name, handler) {
        this.handlers.set(name, (this.handlers.get(name) || []).concat(handler));
    }
    unsubscribe(name, handler) {
        this.handlers.set(name, (this.handlers.get(name) || []).filter(h => h != handler));
    }
    emit(name, event) {
        (this.handlers.get(name) || []).forEach(h => {
            try {
                h(event);
            }
            catch (e) {
                console.error('could not invoke event listener', e);
            }
        });
    }
}

let bus = null;
function getBus() {
    if (bus !== null) {
        return bus;
    }
    if (typeof window === 'undefined') {
        // testing or SSR
        return new Proxy({}, {
            get: () => {
                return () => console.error('Window not available, EventBus can not be established!');
            }
        });
    }
    if (typeof window.OC !== 'undefined' && window.OC._eventBus && typeof window._nc_event_bus === 'undefined') {
        console.warn('found old event bus instance at OC._eventBus. Update your version!');
        window._nc_event_bus = window.OC._eventBus;
    }
    // Either use an existing event bus instance or create one
    if (typeof window?._nc_event_bus !== 'undefined') {
        bus = new ProxyBus(window._nc_event_bus);
    }
    else {
        bus = window._nc_event_bus = new SimpleBus();
    }
    return bus;
}
/**
 * Register an event listener
 *
 * @param name name of the event
 * @param handler callback invoked for every matching event emitted on the bus
 */
function subscribe(name, handler) {
    getBus().subscribe(name, handler);
}
/**
 * Unregister a previously registered event listener
 *
 * Note: doesn't work with anonymous functions (closures). Use method of an object or store listener function in variable.
 *
 * @param name name of the event
 * @param handler callback passed to `subscribed`
 */
function unsubscribe(name, handler) {
    getBus().unsubscribe(name, handler);
}
/**
 * Emit an event
 *
 * @param name name of the event
 * @param event event payload
 */
function emit(name, event) {
    getBus().emit(name, event);
}

export { ProxyBus, SimpleBus, emit, subscribe, unsubscribe };
//# sourceMappingURL=index.mjs.map
